export default "         ,\\\n         \\\\\\,_\n          \\` ,\\\n     __,.-\" =__)\n   .\"        )\n,_/   ,    \\/\\_\n\\_| )_-\\ \\_-`\n   `-----` `--`"